<template>
  <customer-template :type="1"/>
</template>

<script>
import CustomerTemplate from '@/views/basedata/customer_basedata/CustomerTemplate.vue'

export default {
  name: 'SupplierBaseData',
  components: { CustomerTemplate }
}
</script>